import type { Fn, IgnoreAny } from "./types";

export function on<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args: Parameters<T["addEventListener"]> | [string, Fn | null, ...IgnoreAny]
): void {
  if (obj && obj.addEventListener) {
    obj.addEventListener(...(args as Parameters<HTMLElement["addEventListener"]>));
  }
}

export function off<T extends Window | Document | HTMLElement | EventTarget>(
  obj: T | null,
  ...args: Parameters<T["removeEventListener"]> | [string, Fn | null, ...IgnoreAny]
): void {
  if (obj && obj.removeEventListener) {
    obj.removeEventListener(...(args as Parameters<HTMLElement["removeEventListener"]>));
  }
}

export const defaultWindow = /* #__PURE__ */ typeof window !== "undefined" ? window : undefined;
export const defaultDocument =
  /* #__PURE__ */ typeof document !== "undefined" ? document : undefined;
